<template lang="jade">
	
	.asw-auschart(v-if="this.results")
		transition(appear, name="fade", mode="out-in")
			//-template
				//-.asw-auschart_title
					|{{ 'Australia' }}
			.asw-auschart_chart
				svg.asw-sentiment_svg(:width="chart_aus.width", :height="chart_aus.height")
					g.asw-sentiment_svg_g(:transform="chart_aus_transform")
						g.arc(v-for="item in chart_aus_paths")
							path(:d="item.d", :style="{ fill: item.fill }")
							g.arcText
								text(:transform="item.pieTexttransform", :style="{ fill: item.fill, 'text-anchor': 'middle' }", x='0', y='0' ) 
									tspan.value(x="0", dy="1.2em") {{ item.data.value }}% 
									tspan.name(x="0", dy="1.2em") {{ item.data.name}}
						text.title(x='0', y='-1.2em') 
							tspan.aus(x="0", dy="1.2em", :style="{ 'text-anchor': 'middle' }")|{{ 'Australia' }}
							tspan.feels(x="0", dy="1.2em", :style="{ 'text-anchor': 'middle' }")|{{ 'feels' }}
								
</template>
<script>

	import d3arc from "d3-shape/src/arc";
	import d3pie from "d3-shape/src/pie";

	export default {
		name: "auschart",
		props: {
			results: {
				type: Object,
				required: true
			},
			emojiData: {
				type: Object,
				required: true
			}
		},
		data: () => ({
			chart_aus: {
				width: 160,
				height: 160
			}
		}),
		computed: {
			ausPollResult() {
				return this.results.regions.overall;
			},
			pie() {
				return d3pie().sort(null).value(function(d) { return d.value; });
			},
			chart_aus_transform() {
				return "translate(" + this.chart_aus.width / 2 + "," + this.chart_aus.height / 2 + ")";
				//return "translate(" + this.chart_aus.width + "," + this.chart_aus.height + ")";
			},
			chart_aus_data() {
				const total = this.ausPollResult.total;
				
				return [
					{ name: 'furious', value: this.percentify(this.ausPollResult.items.furious, total) },
					{ name: 'depressed', value: this.percentify(this.ausPollResult.items.depressed, total) },
					{ name: 'worried', value: this.percentify(this.ausPollResult.items.worried, total) },
					{ name: 'meh', value: this.percentify(this.ausPollResult.items.meh, total) },
					{ name: 'happy', value: this.percentify(this.ausPollResult.items.happy, total) },
					{ name: 'stoked', value: this.percentify(this.ausPollResult.items.stoked, total) },
				];
			},
			chart_aus_paths() {
				const
					radius = Math.min(this.chart_aus.width, this.chart_aus.height) / 2,
					arc = d3arc().outerRadius(radius - 10).innerRadius(radius - 30),
					pieData = this.pie(this.chart_aus_data);

				return pieData.map((d) => ({
					...d,
					d: arc(d),
					fill: this.emojiColorFn(d.data.name), // color(d.data.value)
					pieTexttransform: this.pietext_transform( arc.centroid(d), d )

				}) );

			}
			
		},
		mounted() {
			//console.log('That',this);
		},
		methods: {
			emojiColorFn(name) {
				return this.emojiData[name].color;
			},
			percentify(count,total) {
				return Math.round(count/total * 100);
			},
			pietext_transform(arcCentroid, d) {
				
				const dangle = (d.endAngle + d.startAngle)/2;

				if (dangle > 0 && dangle <= 1.0 ) {
					arcCentroid[0] *= 2.0;
					arcCentroid[1] *= 2.0;
				} else if (dangle > 1 && dangle <= 1.8 ) {
					arcCentroid[0] *= 1.8;
					arcCentroid[1] *= 2.0;
				} else if (dangle > 1.8 && dangle <= 3 ) {
					arcCentroid[0] *= 2.0;
					arcCentroid[1] *= 1.2;
				} else if (dangle > 3 && dangle <= 4.2 ) {
					arcCentroid[0] *= 2.0;
					arcCentroid[1] *= 1.1;
				} else if (dangle > 4.2 && dangle <= 5.4 ) {
					arcCentroid[0] *= 1.8;
					arcCentroid[1] *= 3.1;
				} else {
					arcCentroid[0] *= 2.0;
					arcCentroid[1] *= 2.0;
				}
				
				return "translate(" + arcCentroid + ")";

			}
		}
	}
</script>
<style lang="scss">
	@import "src/assets/scss/global-sass";

	.asw-auschart {
		text-align:center;
		margin-top:-149px;
		z-index: 10;
		width: 331px;
		height:175px;
		margin-left:30px;
		
		@media only screen and (max-width: 600px) {
			  margin:0 auto;
		}
		
		&_inner {
			padding: 12px;
		    overflow: auto;
		    height: 100%;
		}

		&_title {
			margin: -#{$m-spacing} $m-spacing-x4;
		}
		.tge-componenttitle_text {
			font-size: 22px;
		}

		&_chart {
			path {
				stroke:#fff;
			}
			svg:not(:root) {
				overflow:visible;
			}
		}

		tspan {
			&.name {
				font-size:12px;
			}
			&.value {
				font-weight: bold;
			}
		}
		.title {
			font-weight: bold;
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/AusChart.vue